import { useState } from "react"
import { IconContainer } from "../../Buttons/IconContainer"
import { UnderlinedButton } from "../../Buttons/UnderlinedButton"
import { VerificationStep } from "./VerificationStep"
import { VerificationUpload } from "./VerificationUpload"
import VerifiedIcon from "../../../public/images/icons/verified.svg";
import { verify } from "@jconradi/tutu-porn-api-client/src/me"
import { Spinner } from "../../Spinner/Spinner"
import Link from "next/link"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const SubmitVerification = () => {
    const [idFile, setIdFile] = useState<File | undefined>();
    const [selfyFile, setSelfyFile] = useState<File | undefined>();
    const [loading, setLoading] = useState<boolean>(false);
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: verify,
        onSuccess: data => {
            queryClient.setQueryData(['me'], data)
        }
    })

    const submit = async () => {
        if (loading || !selfyFile || !idFile) {
            return;
        }

        setLoading(true);

        try {
            const formData = new FormData();
            formData.append("id", idFile, idFile.name);
            formData.append("selfy", selfyFile, selfyFile.name);

            await mutation.mutateAsync(formData);
        }
        catch (err) {
            console.error(err);
        }
        finally {
            setLoading(false);
        }
    }

    return (
        <>
            <div className="bg-base-300 rounded-[24px] p-[20px] md:p-20">
                <h2 className="font-bold text-2xl md:text-5xl mb-6 md:leading-[44px] flex flex-row items-center justify-between md:justify-center md:gap-x-4">Content Creator Verification
                    <VerifiedIcon className="w-8 h-8 md:w-12 md:h-12 flex-none" />
                </h2>
                <p> Thank you for your interest in wanting to become a TutuPorn Verified Content Creator! Becoming a Verified Content Creator on TutuPorn means your profile will stand out and attract more attention. You can earn money from selling your videos, and photos on Tutu Porn.  To become verified please complete the following steps: </p>
            </div>

            <VerificationStep disabled={true} step="1" title="Upload Your Id" description={<>
                <p>Please upload a Government issued ID (Drivers License, Passport, National ID, etc).</p>
            </>} actions={<VerificationUpload setFile={setIdFile} />} />

            <VerificationStep step="2" title="Upload Your Selfy" description={<>
                <p>Please ensure the selfy you upload fulfils the following requirements:</p>
                <ul className="list-disc list-outside">
                    <li className="ml-4 mb-6">SFW photo of you holding a sign with your TutuPorn profile URL written on it which is: <Link href="#"></Link></li>
                    <li className="ml-4 mb-6">Photo must include you holding the ID that you uploaded in step #1.</li>
                </ul>
            </>} actions={<VerificationUpload setFile={setSelfyFile} />} />

            <VerificationStep step="3" title="Submit Your Application" description={
                <p>You will receive an email notification to confirm your account verification.</p>}
                actions={
                    <UnderlinedButton onClick={submit} disabled={!idFile || !selfyFile || loading} underlineType="primary" className="mx-auto mt-4 md:mt-0">
                        <IconContainer responsiveText={false} label="Verify Account" icon={loading ? <Spinner /> : <VerifiedIcon className="w-8 h-8" />} />
                    </UnderlinedButton>
                } />
        </>
    )
}